var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-900 bg-opacity-50 fixed inset-0 flex justify-center items-center transition-opacity",class:{ 'opacity-0': _vm.transparent },on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }